<template>
  <div class="Activities">
    <Activities msg="Jaja hier ein Text"/>
  </div>
</template>

<script>
// @ is an alias to /src
import Activities from '@/components/Tables/Table.vue'

export default {
  name: 'activities',
  components: {
    Activities
  }
}
</script>
